import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { resetBoard } from "../features/boardSlice";

const Header = () => {
  const dispatch = useDispatch();
  const { moves, level, won } = useSelector((store) => store.board);

  return (
    <div className="header">
      <div>
        <h2 className="game-name">Memory Game</h2>
      </div>
      {won && (
        <button className="start-btn" onClick={() => dispatch(resetBoard())}>
          START NEW GAME
        </button>
      )}
      <div className="status">
        <div className="left"> MOVES: {moves}</div>
        <div className="right">LEVEL: {level + 1}</div>
      </div>
    </div>
  );
};

export default Header;
